import { render, staticRenderFns } from "./ListMomen.vue?vue&type=template&id=15424ca6&scoped=true"
import script from "./ListMomen.vue?vue&type=script&lang=js"
export * from "./ListMomen.vue?vue&type=script&lang=js"
import style0 from "./ListMomen.vue?vue&type=style&index=0&id=15424ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15424ca6",
  null
  
)

export default component.exports